import {Control as OLControl} from "ol/control";

/** @typedef {import("ol/control/Control").Options} ControlOptions */

/** @typedef {import("primereact/overlaypanel").OverlayPanel} OverlayPanel */

/**
 * @typedef {ControlOptions} LegendControlOptions
 * @property {MutableRefObject<OverlayPanel|null>} [legendOverlayRef]
 * @property {string} [buttonLabel]
 * @property {boolean} visible
 */

export default class OpenLayersLegendControl extends OLControl {
    /**
     * @param {LegendControlOptions} opt_options
     */
    constructor(opt_options) {
        const options = opt_options || {};

        const button = document.createElement("button");

        const element = document.createElement("div");
        element.className = "ol-unselectable ol-control legend-button";
        element.appendChild(button);

        super({
            element: element,
            target: options.target,
        });

        this.legendOverlayRef = opt_options.legendOverlayRef;
        this.button = button;

        const buttonLabel = opt_options.buttonLabel || "Erläuterung";
        this.updateButtonLabel(buttonLabel);

        button.addEventListener("click", this.handleOverlayToggle.bind(this), false);

        setTimeout(() => {
            if (opt_options.visible) this.legendOverlayRef.current.show(null, button);
        }, 100);
    }

    /**
     * @param {string} buttonLabel
     */
    updateButtonLabel(buttonLabel) {
        this.button.innerHTML = `<span class="pi pi-info-circle"></span> ${buttonLabel}`;
    }

    /**
     * Blendet Button + Overlay der Legende zur Laufzeit ein/aus, OHNE die Karte neu aufzubauen.
     * So kann z.B. der Emissionen-Tab die Lärmklassen-Legende beim Familienwechsel verstecken,
     * ohne die (flackernde) Neuerstellung der Karte über einen React-key auszulösen.
     * @param {boolean} visible
     */
    setVisible(visible) {
        this.element.style.display = visible ? "" : "none";
        const overlay = this.legendOverlayRef?.current;
        if (!overlay) return;
        if (visible) {
            overlay.show(null, this.button);
        } else if (typeof overlay.hide === "function") {
            overlay.hide();
        }
    }

    handleOverlayToggle(e) {
        if (this.legendOverlayRef.current && typeof this.legendOverlayRef.current.toggle === "function") {
            this.legendOverlayRef.current.toggle(e);
        }
    }
}
